import { AlpineComponent } from 'alpinejs';
import 'swiper/css';
import 'swiper/css/navigation';

const StageComponent = (): AlpineComponent => ({

  init() {
  },

  selectEdition(event: any) {
    // console.log('Select', event);
    // console.log(event.target.value);
    window.location.href = event.target.value;
  },

  scrollDown() {
    const mainContent = document.getElementsByTagName('main');

    if (!mainContent.length) return;

    const mainElement = mainContent[0];
    mainElement.scrollIntoView({ behavior: 'smooth' });
  }
    
});

export default StageComponent;
